/* Modules */
import Navigation from './modules/Navigation';
import BgImgSlider from './modules/BgImgSlider';
import ExternalEvents from './modules/ExternalEvents';

document.addEventListener('DOMContentLoaded', () => {
  let navigation = document.querySelector('.js-navigation');

  if (navigation) {
    new Navigation(navigation);
  }

  // Background Image Slider
  const bgImgSliders = document.querySelectorAll('.js-bg-img-slider');
  if (bgImgSliders.length > 0) {
    bgImgSliders.forEach((bgImgSlider) => {
      new BgImgSlider(bgImgSlider);
    });
  }

  const externalEventBlocks = document.querySelectorAll('.js-external-events');
  if (externalEventBlocks.length > 0) {
    externalEventBlocks.forEach((block) => {
      new ExternalEvents(block);
    });
  }


});
